import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CalendarIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export const NewDiveEntry: React.FC = () => {
  return <div data-id="element-1250">
      <Link to="/dives" className="flex items-center text-primary mb-4" data-id="element-1251">
        <ArrowLeftIcon size={16} className="mr-1" data-id="element-1252" />
        <span data-id="element-1253">Back to Dive Log</span>
      </Link>
      <div className="flex justify-between items-center mb-6" data-id="element-1254">
        <h1 className="text-2xl font-bold text-navy" data-id="element-1255">Log New Dive</h1>
      </div>
      <Card className="mb-6" data-id="element-1256">
        <h2 className="font-semibold mb-4" data-id="element-1257">Dive Details</h2>
        <div className="space-y-4" data-id="element-1258">
          <div data-id="element-1259">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1260">
              Dive Site
            </label>
            <div className="relative" data-id="element-1261">
              <input type="text" className="w-full p-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="Enter dive site name" data-id="element-1262" />
              <MapPinIcon size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1263" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-1264">
            <div data-id="element-1265">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1266">
                Date
              </label>
              <div className="relative" data-id="element-1267">
                <input type="date" className="w-full p-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1268" />
                <CalendarIcon size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1269" />
              </div>
            </div>
            <div data-id="element-1270">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1271">
                Time
              </label>
              <div className="relative" data-id="element-1272">
                <input type="time" className="w-full p-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1273" />
                <ClockIcon size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1274" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-1275">
            <div data-id="element-1276">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1277">
                Max Depth (m)
              </label>
              <input type="number" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="18" data-id="element-1278" />
            </div>
            <div data-id="element-1279">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1280">
                Duration (min)
              </label>
              <input type="number" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="45" data-id="element-1281" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-1282">
            <div data-id="element-1283">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1284">
                Water Temp (°C)
              </label>
              <input type="number" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="24" data-id="element-1285" />
            </div>
            <div data-id="element-1286">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1287">
                Visibility (m)
              </label>
              <input type="number" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="15" data-id="element-1288" />
            </div>
          </div>
          <div data-id="element-1289">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1290">
              Dive Type
            </label>
            <select className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1291">
              <option data-id="element-1292">Boat Dive</option>
              <option data-id="element-1293">Shore Dive</option>
              <option data-id="element-1294">Drift Dive</option>
              <option data-id="element-1295">Night Dive</option>
              <option data-id="element-1296">Deep Dive</option>
              <option data-id="element-1297">Cave Dive</option>
              <option data-id="element-1298">Wreck Dive</option>
            </select>
          </div>
          <div data-id="element-1299">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1300">
              Buddy
            </label>
            <input type="text" className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" placeholder="Buddy name" data-id="element-1301" />
          </div>
          <div data-id="element-1302">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1303">
              Notes
            </label>
            <textarea className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary h-24" placeholder="Add notes about your dive experience..." data-id="element-1304"></textarea>
          </div>
        </div>
      </Card>
      <Card className="mb-6" data-id="element-1305">
        <h2 className="font-semibold mb-4" data-id="element-1306">Equipment</h2>
        <div className="space-y-4" data-id="element-1307">
          <div className="flex items-center" data-id="element-1308">
            <input type="checkbox" id="equipment-1" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1309" />
            <label htmlFor="equipment-1" className="ml-2 text-gray-700" data-id="element-1310">
              BCD
            </label>
          </div>
          <div className="flex items-center" data-id="element-1311">
            <input type="checkbox" id="equipment-2" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1312" />
            <label htmlFor="equipment-2" className="ml-2 text-gray-700" data-id="element-1313">
              Regulator
            </label>
          </div>
          <div className="flex items-center" data-id="element-1314">
            <input type="checkbox" id="equipment-3" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1315" />
            <label htmlFor="equipment-3" className="ml-2 text-gray-700" data-id="element-1316">
              Dive Computer
            </label>
          </div>
          <div className="flex items-center" data-id="element-1317">
            <input type="checkbox" id="equipment-4" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1318" />
            <label htmlFor="equipment-4" className="ml-2 text-gray-700" data-id="element-1319">
              Wetsuit
            </label>
          </div>
          <div className="flex items-center" data-id="element-1320">
            <input type="checkbox" id="equipment-5" className="w-4 h-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-1321" />
            <label htmlFor="equipment-5" className="ml-2 text-gray-700" data-id="element-1322">
              Camera
            </label>
          </div>
        </div>
      </Card>
      <Card className="mb-6" data-id="element-1323">
        <h2 className="font-semibold mb-4" data-id="element-1324">Upload Photos</h2>
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-1325">
          <p className="text-gray-500 mb-2" data-id="element-1326">Drag and drop photos here</p>
          <Button variant="outline" size="sm" data-id="element-1327">
            Browse Files
          </Button>
        </div>
      </Card>
      <div className="flex justify-end gap-4 mb-8" data-id="element-1328">
        <Button variant="outline" data-id="element-1329">Cancel</Button>
        <Button variant="primary" data-id="element-1330">Save Dive</Button>
      </div>
    </div>;
};